/* eslint-disable react-hooks/exhaustive-deps */
// Chakra imports
import { Box, Flex, Text, Select, useColorModeValue } from "@chakra-ui/react";
// Custom components
import Card from "components/card/Card.js";
import PieChart from "components/charts/PieChart";
import { pieChartOptions } from "variables/charts";
import React, { useEffect, useState } from "react";
import { monthOption,generateYearOptions } from "./filterOption";


const {yearOption,defaultSelected} = generateYearOptions();


export default function Conversion(props) {
  const { ...rest } = props;

  const [expensesData, setExpensesData] = useState([]);
  const [expensesAmount, setExpenseAmount] = useState([]);
  const [chartOptions,setChartOptions] = useState({})
  const [fillColors,setFillColors] = useState([])
  const [piChartTypeOption, setPiChartTypeOption] = useState("yearly");

  useEffect(() => {
    if (!props?.data || props?.data.length === 0) {
      setChartOptions(pieChartOptions);
      setExpensesData([]);
      setExpenseAmount([]);
      setFillColors([]);
      return;
    }
    const labels = props?.data.map(item => item.name);
    const amounts = props?.data.map(item => item.amount);
    const colors = props?.data.map(item => item.color || "#21263c");
    setExpensesData(props?.data);
    setExpenseAmount(amounts);
    setFillColors(colors);
    setChartOptions({
      ...pieChartOptions,
      labels,
      fill: {
        colors,
        opacity: 0.8
      }
    });
  }, [props?.data]);
  
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const cardColor = useColorModeValue("white", "navy.700");
  const cardShadow = useColorModeValue(
    "0px 18px 40px rgba(112, 144, 176, 0.12)",
    "unset"
  );

  
  return (
    <Card
      p={0}
      align="center"
      direction="column"
      mx={20}
      w="88%"
      {...rest}
      className="weekly-expense-graph"
    >
      <Flex
        className="weekly-graph-flex"
        alignItems="center"
        justifyContent="space-between"
        w="100%"
        mb={10}
      >
        <Text>Expenses Pie Chart</Text>
        <Select
          fontSize="sm"
          variant="subtle"
          defaultValue="yearly"
          width="unset"
          fontWeight="700"
          onChange={(e) => {
            props.changePiType(e.target.value);
            setPiChartTypeOption(e.target.value);
          }}
        >
          <option value="monthly">Monthly</option>
          <option value="yearly">Yearly</option>
        </Select>
        <Select
          fontSize="sm"
          variant="subtle"
          defaultValue={defaultSelected}
          width="unset"
          fontWeight="700"
          onChange={(e) => {
            props.changePiYear(e.target.value);
          }}
        >
          <option value="">finance year</option>
          {yearOption.map((opt) => {
            return <option value={opt.value}>{opt.label}</option>;
          })}
        </Select>
        {piChartTypeOption === "monthly" && (
          <Select
            fontSize="sm"
            variant="subtle"
            defaultValue="12"
            width="unset"
            fontWeight="700"
            onChange={(e) => {
              props.changePiMonth(e.target.value);
            }}
          >
            {monthOption.map((opt) => {
              return <option value={opt.value}>{opt.label}</option>;
            })}
          </Select>
        )}
      </Flex>

      <Box h="100%" mt={10}>
        <PieChart
          h="100%"
          w="100%"
          chartData={expensesAmount}
          chartOptions={chartOptions}
        />
      </Box>
      <Card
        bg={cardColor}
        flexDirection="row"
        boxShadow={cardShadow}
        w="100%"
        p="15px"
        px="20px"
        mx="auto"
      >
        <Flex direction="row" p="5px" me="20px" wrap="wrap">
          {expensesData &&
            expensesData.length > 0 &&
            expensesData.map((item, i) => {
              return (
                <Flex key={i} direction="column" className="mx-2" width="20%">
                  {" "}
                  <Box display="flex">
                    <Box
                      h="8px"
                      w="8px"
                      bg={fillColors[i]}
                      borderRadius="50%"
                      me="4px"
                      mt={1}
                    />
                    <Text
                      fontSize="xs"
                      color="secondaryGray.600"
                      fontWeight="700"
                    >
                      {item?.name}
                    </Text>
                  </Box>
                  <Text fontSize="lg" color={textColor} fontWeight="700">
                    {Number(item.prc || 0)?.toFixed(2)}%
                  </Text>
                </Flex>
              );
            })}
        </Flex>
      </Card>
    </Card>
  );
}
